module.exports = __webpack_public_path__ + "static/img/login-bgc.77dadcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/login/img/login-bgc.png
// module id = vznf
// module chunks = 3